<template>
  <div class="recrutment_main bg_">
    <div class="page-banner">
      <!-- <img src="../assets/pcImg/joinbanner.jpg" alt /> -->
      <img :src="subBannerImgurl" alt />
    </div>

    <div class="join_main">
      <div class="tab_list animate__animated animate__fadeInUp">
        <img src="../assets/pcImg/company/tabbg.png" alt class="tab_img" />
        <div class="all_c">
          <div class="intro_" @click="myTab(0)">
            <img src="../assets/pcImg/work/resume.png" alt />
            社会招聘
          </div>
          <div class="history_" @click="myTab(1)">
            <img src="../assets/pcImg/work/teambuild.png" alt />
            团队建设
          </div>
        </div>
        <div class="light_line" :class="tab == 1 ? 'two_line' : ''"></div>
      </div>
      <div class="resume_dom" v-if="tab == 0">
        <div class="join_left fl animate__animated animate__fadeInLeft">
          <div class="work_place">
            <div class="title">工作地点</div>
            <div class="work_list">
              <div class="work_items" v-for="(item, index) in joinArea" :key="index" @click="myAreaChoose(item.id)">
                <img src="../assets/pcImg/work/select_.png" v-if="areaChoose.indexOf(item.id) === -1" alt />
                <img src="../assets/pcImg/work/select_in.png" v-else alt />
                <span>{{ item.name }}</span>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <div class="work_type">
            <div class="title">工作类型</div>
            <div class="work_list">
              <div class="work_items animate__animated animate__fadeInLeft" v-for="(item, index) in joinType" :key="index" @click="myTypeChoose(item.id)">
                <img src="../assets/pcImg/work/select_.png" v-if="typeChoose.indexOf(item.id) === -1" alt />
                <img src="../assets/pcImg/work/select_in.png" v-else alt />
                <span>{{ item.name }}</span>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <div class="tips">
            简历投递方式：
            <br />“姓名+投递岗位” 命名的个人简历
            <br />投递到邮箱
            hr@iclockwork.com
          </div>
        </div>
        <div class="join_right fl">
          <div class="join_right_main" v-if="joinList.length > 0 && !loading">
            <div class="join_job_list">
              <div v-for="(item, index) in joinList" :key="item.id" class="join_item animate__animated animate__fadeInRight" :class="'animate__delay-'+index+'s'">
                <div class="title" :class="itemShow[index] ? 'title_active' : ''">
                  {{ item.name }} /
                  <span>{{ item.position.name }}</span>
                </div>
                <div :class="itemShow[index] ? 'contrle_ active' : 'contrle_'" @click="changeShow(index)"></div>
                <div class="detail" :class="itemShow[index] ? 'detail_active' : ''">
                  <div class="responsibility">
                    <p>{{ $t("m.joinus.responsibility") }}</p>
                    <p v-html="item.responsibility"></p>
                  </div>
                  <div class="require">
                    <p>{{ $t("m.joinus.require") }}</p>
                    <p v-html="item.requirement"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="no_result" v-if="joinList.length == 0 && !loading">———— 暂无招聘信息 ————</div>
          <loading v-if="loading"></loading>
        </div>
      </div>
      <div class="teambuild_dom" v-else>
        <company-team></company-team>
      </div>
    </div>
    <loading v-if="loading" class="loading"></loading>
  </div>
</template>
<script>
import CompanyTeam from './CompanyTeam'
import Loading from './loading'
export default {
  components: { CompanyTeam, Loading },
  data() {
    return {
      joinType: [],
      joinList: [],
      joinArea: [],
      areaChoose: [],
      typeChoose: [],
      itemShow: [],
      activeList: 0,
      langs: 'zh',
      recruit_method: '社招',
      tab: 0, //0社会招聘 1团队建设
      subBannerImgurl: '',
      loading: true,
    }
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.getSubBannerImgurl()
    this.init()
    this.getJob()
  },
  methods: {
    getSubBannerImgurl: function () {
      let datas = {
        position: 4,
      }
      this.getHttp(this, datas, '/front/page/banner', function (obj, data) {
        if (data.status == 2000) {
          obj.subBannerImgurl = data.data[0].img_url
        } else {
          console.log(data.message)
        }
      })
    },
    init(e) {
      this.getHttp(this, '', '/front/job/getPositions', function (obj, data) {
        if (data.status == 2000) {
          obj.joinType = data.data
        } else {
          console.log(data.message)
        }
      })
      this.getHttp(this, '', '/front/job/getCities', function (obj, data) {
        if (data.status == 2000) {
          obj.joinArea = data.data
        } else {
          console.log(data.message)
        }
      })
    },
    getJob() {
      var datas = {
        cities: this.areaChoose,
        positions: this.typeChoose,
        recruit_method: this.recruit_method,
      }
      this.getHttp(this, datas, '/front/job/getJobs', function (obj, data) {
        if (data.status == 2000) {
          obj.joinList = data.data
          obj.itemShow = []
          for (var i in data.data) {
            obj.itemShow.push(false)
          }
        } else {
          console.log(data.message)
        }
        obj.loading = false
      })
    },
    recruit(e) {
      this.recruit_method = e
      this.getJob()
    },
    changeShow(e) {
      let valuse = !this.itemShow[e]
      this.itemShow.splice(e, 1, valuse)
    },
    myAreaChoose(e) {
      this.loading = true
      if (this.areaChoose.indexOf(e) !== -1) {
        this.areaChoose.splice(this.areaChoose.indexOf(e), 1)
      } else {
        this.areaChoose.push(e)
      }

      this.getJob()
    },
    myTypeChoose(e) {
      this.loading = true
      if (this.typeChoose.indexOf(e) !== -1) {
        this.typeChoose.splice(this.typeChoose.indexOf(e), 1)
      } else {
        this.typeChoose.push(e)
      }
      this.getJob()
    },
    myTab(e) {
      this.tab = e
    },
  },
}
</script>
<style lang="scss" scoped>
.animate__animated.animate__delay-1s {
  animation-delay: 0.1s;
}
.animate__animated.animate__delay-2s {
  animation-delay: 0.2s;
}
.animate__animated.animate__delay-3s {
  animation-delay: 0.3s;
}
.animate__animated.animate__delay-4s {
  animation-delay: 0.4s;
}
.animate__animated.animate__delay-5s {
  animation-delay: 0.5s;
}
.animate__animated.animate__delay-6s {
  -webkit-animation-delay: 6s;
  -moz-animation-delay: 6s;
  -o-animation-delay: 6s;
  animation-delay: 0.6s;
}
.animate__animated.animate__delay-7s {
  animation-delay: 0.7s;
}
.animate__animated.animate__delay-8s {
  animation-delay: 0.8s;
}
.animate__animated.animate__delay-9s {
  animation-delay: 0.9s;
}
.animate__animated.animate__delay-10s {
  animation-delay: 1s;
}
.animate__animated.animate__delay-11s {
  animation-delay: 1.1s;
}
.animate__animated.animate__delay-12s {
  animation-delay: 1.2s;
}
.animate__animated.animate__delay-13s {
  animation-delay: 1.3s;
}
.animate__animated.animate__delay-14s {
  animation-delay: 1.4s;
}
.animate__animated.animate__delay-15s {
  animation-delay: 1.5s;
}
.bg_ {
  background: #1d222c !important;
}
.page-banner {
  width: 100%;
  height: 0;
  padding-bottom: 32.38%;
  position: relative;
  background: #202630;
}
.page-banner img {
  width: 100%;
}
.join_main {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  min-height: 10.25rem;
  background-color: #161822;
  display: flex;
  align-items: stretch;
  flex-flow: row wrap;
  .tab_list {
    width: 100%;
    height: 0.83rem;
    position: relative;
    z-index: 2;
    .tab_img {
      width: 100%;
      display: block;
      height: 0.83rem;
    }
    .all_c {
      width: 8rem;
      position: absolute;
      left: 50%;
      top: 0;
      margin-left: -4rem;
      height: 0.83rem;
    }
    .intro_,
    .history_,
    .team_ {
      width: 50%;
      height: 0.83rem;
      line-height: 0.83rem;
      font-size: 0.21rem;
      color: white;
      position: absolute;
      left: 50%;
      top: 0;
      text-align: center;
      cursor: pointer;
    }
    .intro_ {
      left: 0;
      img {
        width: 0.26rem;
        margin-right: 0.05rem;
      }
    }
    .history_ {
      right: 0;
      img {
        width: 0.26rem;
        margin-right: 0.05rem;
      }
    }
    .team_ {
      margin-left: 2rem;
      img {
        width: 0.26rem;
        margin-right: 0.05rem;
      }
    }
    .light_line {
      width: 2.01rem;
      height: 0.03rem;
      background-color: chocolate;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -2.99rem;
      border-radius: 1.5px;
      transition: margin-left 0.5s ease;
    }
    .two_line {
      margin-left: 1.01rem;
    }
    .three_line {
      margin-left: 3.35rem;
    }
  }
  .teambuild_dom,
  .resume_dom {
    width: 100%;
  }
  .join_left {
    width: 4.4rem;
    border: 1px solid;
    min-height: 9.5rem;
    height: 100%;
    background-color: #313945;
    .work_place,
    .work_type {
      width: 100%;
      color: white;
      .title {
        border-bottom: 1px solid #5d636d;
        font-size: 0.24rem;
        padding: 0.75rem 0.3rem 0.2rem 0.45rem;
      }
      .work_list {
        width: 80%;
        display: flex;
        margin-left: 0.45rem;
        flex-flow: row wrap;
        .work_items {
          height: 0.4rem;
          width: 1.2rem;
          line-height: 0.4rem;
          cursor: pointer;
          margin-top: 0.2rem;
          margin-right: 0.2rem;
          img {
            width: 0.2rem;
            display: block;
            float: left;
            margin-top: 0.1rem;
            margin-right: 0.1rem;
          }
          span {
            font-size: 0.18rem;
            display: block;
            float: left;
          }
        }
      }
    }
    .join_type {
      width: 1.45rem;
      height: 0.55rem;
      line-height: 0.55rem;
      text-align: center;
      color: white;
      font-size: 16px;
      box-sizing: border-box;
      margin-bottom: 0.6rem;
      cursor: pointer;
    }
    .join_type.active {
      // border: 2px solid #f08200;
      // border-radius: 0.28rem;
      background-image: linear-gradient(to bottom, #faa605, #d46336);
    }
    .tips {
      width: 3.8rem;
      color: white;
      font-size: 0.16rem;
      line-height: 0.3rem;
      margin-top: 2rem;
      border-radius: 0.2rem;
      margin-left: 0.45rem;
    }
  }
  .join_right {
    width: 9.5rem;
    margin-top: 1.2rem;
    margin-left: 1.25rem;
    padding-bottom: 1rem;
    height: inherit;
    position: relative;

    .join_area {
      width: 12rem;
      position: absolute;
      top: -1.1rem;
      left: 50%;
      margin-left: -4.7rem;
      display: flex;
      flex-flow: row wrap;
      justify-content: start;
      .area_item {
        width: 2rem;
        height: 0.75rem;
        line-height: 0.75rem;
        font-size: 0.2rem;
        text-align: center;
        color: white;
        border: 1px solid #ef9313;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-right: 0.8rem;
      }
      .area_item:hover {
        background-color: #ef9313;
        background-image: linear-gradient(to bottom, #faa605, #d46336);
      }
      .acitve {
        background-color: #ef9313;
        background-image: linear-gradient(to bottom, #faa605, #d46336);
      }
    }
    .no_result {
      color: white;
      font-size: 0.23rem;
      margin-top: 0.2rem;
      text-align: center;
    }
    .join_right_main {
      // border-radius: 0.2rem 0.2rem 0.25rem 0.25rem;
      background-image: linear-gradient(left, #f9a706 20%, #01fffe);
      position: relative;
      padding-bottom: 0.1rem;
    }
    .join_job_list {
      width: 100%;
      background-color: white;
      // border-radius: 0.2rem;
      overflow-x: hidden;
    }

    .join_item {
      width: 9.5rem;
      position: relative;
      overflow: hidden;

      .contrle_ {
        position: absolute;
        width: 0.2rem;
        height: 0.2rem;
        background: url(../assets/pcImg/add.png) no-repeat;
        background-size: 100% 100%;
        top: 0.4rem;
        right: 0.38rem;
        cursor: pointer;
      }
      .contrle_.active {
        background: url(../assets/pcImg/sub.png) no-repeat;
        background-size: 100% 100%;
      }
      .title {
        color: #333;
        font-size: 0.26rem;
        padding: 0 0.6rem;
        height: 1rem;
        line-height: 1rem;
        border-bottom: 1px solid #d4d2d0;
        span {
          font-size: 0.16rem;
        }
      }
      .title_active {
        background-color: #ebedf0;
      }
      .detail {
        width: 100%;
        font-size: 0.18rem;
        color: #141620;
        line-height: 0.25rem;
        border-bottom: 1px solid #d4d2d0;
        max-height: 0;
        transition: max-height 0.3s ease;
        .responsibility {
          width: 100%;
          margin-bottom: 0.4rem;
          padding: 0.3rem 0.6rem 0 0.6rem;
        }
        .require {
          width: 100%;
          padding: 0 0.6rem 0.3rem 0.6rem;
        }
      }
      .detail_active {
        max-height: 1200px;
      }
    }
    .join_item:last-child {
      .title {
        border-bottom: 0;
      }
      .detail {
        border-bottom: 0;
      }
    }
    .max_height {
      max-height: 12rem;
    }
  }
}

/* 针对缺省样式 (必须的) */
::-webkit-scrollbar {
  width: 0.04rem;
  height: 0px;
}

/* 滚动条的滑轨背景颜色 */
::-webkit-scrollbar-track {
  background-color: #161822;
  border-radius: 0.04rem;
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #0c0e15;
  border-radius: 0.04rem;
}

/*内层轨道的颜色*/
::-webkit-scrollbar-track-piece {
  background-color: #161822;
  border-radius: 0.08rem;
}

/* 滑轨两头的监听按钮颜色 */
::-webkit-scrollbar-button {
  background-color: #161822;
  width: 0;
  height: 0;
}

/* 横向滚动条和纵向滚动条相交处尖角的颜色 */
::-webkit-scrollbar-corner {
  background-color: black;
}
</style>
